import React, { useContext } from "react";
import "./Details.css";
import { Context } from "../../../context/Context";
import { formatter } from "../../../utils/helpers";
import { translations } from "../../../utils/lang";
import { DetailsExpand } from "./detailsExpand/DetailsExpand";
import { ArrowDown, ArrowUp } from "../../ui";
import { rowToggleProps } from "../reportUtils";
import usePagedReport from "../usePagedReport";
import { PagedDeleteDialog, PagedPanel, PagedRows, PagedStates } from "../PagedReportParts";

const KIND = "compensation";
const DETAIL_GROUP_BY = ["month", "app", "branch"];

// Faults (Details) table with server-side filtering, sorting and paging (PAGED_REPORTS). Same cards, same actions, same permissions as
// Details.jsx; the difference is that the browser holds one page of one store at a time and prints server totals for every header.
export const DetailsPaged = ({ active = true }) => {
  const { lang } = useContext(Context);
  const report = usePagedReport({ kind: KIND, detailGroupBy: DETAIL_GROUP_BY, amountField: "orderAmount", active });
  const { text, stores, openStore } = report;
  const titles = translations[lang].reports.details;

  const fields = [
    { key: "app", filterKey: "apps", onChange: (selected) => report.update({ apps: selected }) },
    { key: "store", filterKey: "stores", onChange: report.changeStores },
    { key: "branch", filterKey: "branches", onChange: (selected) => report.update({ branches: selected }) },
    { key: "status", filterKey: "orderStatuses", onChange: (selected) => report.update({ orderStatuses: selected }) },
    { key: "cause", filterKey: "causes", onChange: (selected) => report.update({ causes: selected }), wide: true },
  ];

  return (
    <div className="report-details-table">
      <PagedPanel report={report} prefix="details" titles={titles.inputTitles} fields={fields} />

      <div className="report-details-card-col">
        <div className="report-details-header-card">
          {titles.header.map((item, i) => (
            <p key={i}>
              <strong>{item}</strong>
            </p>
          ))}
        </div>
        <PagedStates report={report} />
        {stores.map((store) => {
          const id = String(store.storeId);
          const isExpanded = openStore === id;
          return (
            <React.Fragment key={id}>
              <div
                {...rowToggleProps(isExpanded, () => report.toggleStore(id))}
                className={`report-details-summary-card ${isExpanded ? "colored" : ""} ${store.pending > 0 ? "notApproved" : ""}`}
              >
                <div className="report-details-p center">
                  <p>
                    <strong>{store.store}</strong>
                  </p>
                  {store.pending > 0 && <span className="report-pending-tag">{text.pendingApproval}</span>}
                </div>
                <div className="report-details-p">
                  <p>
                    <strong>{store.count}</strong>
                  </p>
                </div>
                <div className="report-details-p">
                  <p>
                    <strong>{formatter.format((store.orderAmount || 0).toFixed(2))}</strong>
                  </p>
                </div>
                <div className="report-details-p">
                  <p>
                    <strong>{formatter.format((store.enduranceAmount || 0).toFixed(2))}</strong>
                  </p>
                </div>
                <div className="report-details-p">
                  <p>
                    <strong>{formatter.format((store.refundAmount || 0).toFixed(2))}</strong>
                  </p>
                </div>
                <div className="report-expand-icon">{isExpanded ? <ArrowUp size={18} /> : <ArrowDown size={18} />}</div>
              </div>
              {isExpanded && (
                <PagedRows report={report}>
                  {(anchors, groupRows, hierarchy) => <DetailsExpand data={anchors} groups={groupRows} paged={hierarchy} onRefresh={report.refresh} />}
                </PagedRows>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <PagedDeleteDialog report={report} kind={KIND} />
    </div>
  );
};
